import { render } from "./ShipLineCard.vue?vue&type=template&id=964c5056&ts=true"
import script from "./ShipLineCard.vue?vue&type=script&lang=ts"
export * from "./ShipLineCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__